import React, { FC } from 'react';
import s from './popularToysSection.module.scss';
import { useGetPublicToys } from '@hooks/TRPC_Hooks/useGetToys';
import { useMediaQuery } from '@hooks/useMediaQuery';
import { LogoLoader } from '@components/UIKit/LogoLoader/LogoLoader';
import cn from 'classnames';
import { useTranslation } from '@hooks/useTranslation';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import { ToyCard } from '@components/Cards/ToyCard/ToyCard';
interface Props {}
const id = 'popular_toy_pagination';
export const PopularToysSection: FC<Props> = ({}) => {
  const isTablet = useMediaQuery('(max-width: 991.98px)');
  const {
    translate: tr
  } = useTranslation();
  const {
    data,
    isLoading
  } = useGetPublicToys({
    limit: isTablet ? 6 : 15,
    sort: 'newest'
  });
  return <div className={s.popularToysSection} data-sentry-component="PopularToysSection" data-sentry-source-file="PopularToysSection.tsx">
            <h3 className={cn(s.popularToysSection__title)}>
                {tr({
        id: 'explore.page.trending.toys.title'
      })}
            </h3>
            {isLoading ? <LogoLoader /> : !!data?.items?.length && <>
                    <div className={s.popularToysSection__pagination} id={id} />
                    <div className={s.popularToysSection__slider}>
                        <Swiper slidesPerView={isTablet ? 2 : 5} slidesPerGroup={isTablet ? 2 : 5} speed={1000} loop={true} modules={[Pagination]} pagination={{
          clickable: true,
          el: `#${id}`,
          type: 'bullets'
        }} preventClicks>
                            {data.items.map(props => <SwiperSlide className={s.popularToysSection__slide} key={props.id}>
                                    <ToyCard {...props} />
                                </SwiperSlide>)}
                        </Swiper>
                    </div>
                </>}
        </div>;
};